import { cn } from '@/common/utilities.ts'
import { usePageDescription } from '@/layouts/usePageDescription.ts'
import { useTranslation } from 'react-i18next'

type PageDetailsProps = {
  titleCN?: string
  descriptionCN?: string
}
export default function PageDetails({
  titleCN,
  descriptionCN,
}: PageDetailsProps) {
  const { pageDetails } = usePageDescription()
  const { t: translate } = useTranslation()

  return (
    <>
      <h1
        className={cn(
          'sm:text-xl font-bold leading-none text-gray-900 lg:block hidden',
          titleCN
        )}
      >
        {translate(pageDetails.title)}
      </h1>
      <div
        className={cn(
          'flex items-center gap-2 text-sm font-medium text-gray-500',
          descriptionCN
        )}
      >
        {translate(pageDetails?.description ?? '')}
      </div>
    </>
  )
}
